import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SatinAl = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
    const navigate = useNavigate();

    useEffect(() => {
        const storedIsLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(storedIsLoggedIn);

        if (!storedIsLoggedIn) {
            navigate('/login');
        }
    }, [navigate]);

    return (
        <div>
            {/* Breadcrumb Section */}
            <div className="breadcrumb-section breadcrumb-bg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <div className="breadcrumb-text">
                                <p></p>
                                <h1>Satın Alma</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Purchase Instructions Section */}
            <div className="purchase-instructions mt-150 mb-150">
    <div className="container">
        <div className="row">
            <div className="col-lg-8 offset-lg-2">
                <div className="instructions-text">
                    <h2>Ödeme Yöntemi: Havale/EFT</h2>
                    <p>Ödeme işlemi için lütfen aşağıdaki adımları izleyin:</p>
                    <ol>
                        <li>Bankanız aracılığıyla aşağıdaki hesap bilgilerine havale/eft yapınız:</li>
                        <ul>
                            <li><strong>Hesap Adı:</strong>Mehmet Korkmaz</li>
                            <li><strong>IBAN:</strong> TR39 0006 2000 4860 0006 6312 25</li>
                            <li><strong>Gönderilecek Ücret</strong> 1300 TL (30 günlük üyelik bedelidir.)</li>
                        </ul>
                        <li>Ödeme işlemi tamamlandıktan sonra, havale dekontunu PDF formatında kaydedin.</li>
                        <li>Açıklama kısmına üye olduğunuz e-posta adresinizi veya kullanıcı adınızı yazmayı unutmayın.</li>
                        <li>Siteye kayıt olduğunuz e-posta adresini veya kullanıcı adını açıklamaya yazarak , dekont PDF'ini aşağıda belirtilen e-posta adresine gönderin: <strong>info@tipsmms.com</strong></li>
                    </ol>
                    <p>Lütfen dekontunuzu gönderdikten sonra, işleminizi doğrulamak için biraz zaman ayırınız. İşleminizin onaylanması sonrasında, hizmetlerimizden faydalanabileceksiniz.</p>
                    
                    <div className="email-example">
                        <h3>Örnek E-posta:</h3>
                        <p>Aşağıdaki örnek formatta e-posta gönderebilirsiniz:</p>
                        <img src="/assets/img/satinalma/ornek-mail.png" alt="Örnek Mail" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


        </div>
    );
};

export default SatinAl;
